import fetch from "cross-fetch";
import { CIRCLES_API } from "../../config";
import { shouldFetchCircleDetails } from "./selectors.js";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import { navigate } from "../navigation/operations";
import fetchRetry from "../fetch_retry";

export function fetchCircle(id, is_updating) {
  return function (dispatch, getState) {
    if (!is_updating && !shouldFetchCircleDetails(getState(), id)) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingMyCircles());
    let url = `${CIRCLES_API}/circle/${id}`;

    return fetch(url)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingMyCircles(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorFetchingMyCircles(response.message));
          dispatch(pushNotification("errors.my_circles.fetch", "error"));
        } else {
          dispatch(ActionCreators.fetchedMyCircles([response]));
        }
      });
  };
}

export function fetchMyCircles() {
  return function (dispatch, getState) {
    // if (!shouldFetchCircleDetails(getState(), id)) {
    //   return Promise.resolve();
    // }
    dispatch(ActionCreators.fetchingMyCircles());
    let url = `${CIRCLES_API}/circle/my-circles`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }
    return (
      fetchRetry(url, request_options, dispatch, getState) //test
        // return fetch(url, request_options)
        .then(
          (response) => response.json(),
          (error) => {
            dispatch(ActionCreators.errorFetchingMyCircles(error));
          }
        )
        .then((response) => {
          if ("message" in response || "errors" in response) {
            dispatch(ActionCreators.errorFetchingMyCircles(response.message));
            dispatch(pushNotification("errors.my_circles.fetch", "error"));
          } else {
            dispatch(ActionCreators.fetchedMyCircles(response));
          }
        })
    );
  };
}

export function saveCircle(payload, id, redirect = true) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.savingCircle());
    let url = id ? `${CIRCLES_API}/circle/${id}` : `${CIRCLES_API}/circle`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: id ? "PATCH" : "POST",
      body: JSON.stringify(payload),
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(url, request_options)
    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorSavingCircle(error));
        }
      )
      .then((response) => {
        //TODO: msg: "Token has expired", msg: "Signature verification failed"  -> catch all messages an act according ....
        if ("message" in response || "errors" in response) {
          dispatch(pushNotification("errors.save_circle.error_on_save", "error"));
          dispatch(ActionCreators.errorSavingCircle(response.message));
          return Promise.reject();
        } else {
          dispatch(ActionCreators.savedCircle(response));
          dispatch(pushNotification("success.save_circle.successfully_saved", "success"));
          if (redirect) {
            const circle_guid = id ? id : response["guid"];
            dispatch(navigate(`/circle-toolbox/${circle_guid}`));
          }
          return Promise.resolve(response);
        }
      });
  };
}

export function purchaseItem(circleId) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.markingProductAsBought());
    let url = `${CIRCLES_API}/circle/mark-product-as-bought`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ circle_guid: circleId }),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(url, request_options)
    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorMarkingCircles(error));
        }
      )
      .then((response) => {
        dispatch(ActionCreators.markedProductAsBought());

        // if ("message" in response || "errors" in response) {
        //   dispatch(ActionCreators.errorMarkingCircles(response.message));
        //   dispatch(pushNotification("errors.my_circles.mark", "error"));
        // } else {
        //   debugger
        //   dispatch(ActionCreators.markedProductAsBought([response]));
        // }
      });
  };
}

export const deleteCircleMembership = (payload) => {
  return function (dispatch, getState) {
    dispatch(ActionCreators.removingMember());
    let url = `${CIRCLES_API}/circle/${payload['circle_guid']}/membership/${payload['member_guid']}`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "DELETE",
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }
    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.removingMemberError(error));
          window.location.reload();
        }
      )
      .then((response) => {
        dispatch(ActionCreators.removingMemberSuccess());
        window.location.reload();
      });
  };
};


export const sendCircleRequest = (payload) => {
  return function (dispatch, getState) {
    dispatch(ActionCreators.requestingCircle());
    let url = `${CIRCLES_API}/circle/request-product`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorRequestingCircle(error));
        }
      )
      .then((response) => {
        dispatch(ActionCreators.requestedCircle());
        dispatch(pushNotification("success.circle_request.send_request", "success"));
      });
  };
};

export const sendPuzzleRequest = (payload) => {
  return function (dispatch, getState) {
    dispatch(ActionCreators.sendingPuzzleOrder());
    let url = `${CIRCLES_API}/circle/request-puzzle-invite`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorSendingPuzzleOrder(error));
          dispatch(pushNotification("whitemonday.errors.send_puzzle_form.send_request_error", "error"));
        }
      )
      .then((response) => {
        if (response === "Request sent") {
          dispatch(ActionCreators.sendPuzzleOrder());
          dispatch(pushNotification("whitemonday.success.request_puzzle.success", "success"));
        } else {
          dispatch(ActionCreators.errorSendingPuzzleOrder(response));
          dispatch(pushNotification("whitemonday.errors.send_puzzle_form.send_request_error", "error"));
        }
      });
  };
};

export function inviteFriends(guid, payload) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.invitingFriends());
    let url = `${CIRCLES_API}/circle/${guid}/invite`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ invites: payload }),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorInvitingFriends(error));
        }
      )
      .then((response) => {
        if (response && "invites_sent" in response && response.invites_sent) {
          dispatch(ActionCreators.invitedFriends());
        } else {
          dispatch(ActionCreators.errorInvitingFriends(response));
        }
      });
  };
}

export function markInterest(payload) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.markingInterest());
    let url = `${CIRCLES_API}/circle/mark-interest`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorMarkingInterest(error));
        }
      )
      .then((response) => {
        if (response) {
          dispatch(ActionCreators.markedInterest());
        } else {
          dispatch(ActionCreators.errorMarkingInterest(response));
          return Promise.reject();
        }
      });
  };
}

export function migrateMembers(payload, onSuccess) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.migratingMembers());
    let url = `${CIRCLES_API}/members-migration`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.migratingMembersError(error));
        }
      )
      .then((response) => {
        if ('msg' in response || 'message' in response) {
          dispatch(pushNotification("errors.my_circles.migrate", "error"));
          dispatch(ActionCreators.migratingMembersError(response));
          return Promise.reject();
        }

        if ('migration_successfull' in response) {
          dispatch(ActionCreators.migrateMembersSuccess());
          dispatch(pushNotification("success.my_circles.migrate", "success"));
          if (onSuccess) {
            dispatch(onSuccess);
          }
        }
      });
  };
}
